var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1234,
    height: 166,
    viewBox: "0 0 1234 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_348_10803)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1234,
    height: 166,
    rx: 4,
    fill: "#004A95",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.324 123.564C377.807 122.32 401.106 119.231 425.891 109.456C439.981 103.9 457.861 96.6691 467.303 84.0373C471.368 78.5988 472.59 70.6432 472.959 64.0141C473.591 52.6336 463.709 52.7372 453.585 50.2319C440.004 46.8709 425.918 43.54 411.914 42.5607C406.243 42.1641 401.868 42.3517 399.562 47.7615C397.259 53.1635 400.471 57.1209 405.088 59.8534C421.537 69.5888 443.98 69.1199 462.362 69.2149C486.862 69.3415 511.9 69.7444 536.214 66.4845C548.136 64.886 560.31 64.5059 572.294 65.7044C578.404 66.3153 586.714 66.1454 592.382 68.8249C594.582 69.8645 601.203 72.8807 601.549 75.6509C602.45 82.8611 581.91 90.8717 577.56 93.2037C544.258 111.056 504.025 118.84 467.043 107.701C463.169 106.534 450.394 103.274 450.14 97.5594C450.131 97.3534 450.507 94.3531 450.79 94.3089C476.71 90.2641 503.22 92.0462 529.452 91.8385C619.856 91.1228 710.272 91.6641 800.676 91.9685",
    stroke: "#171717",
    strokeWidth: 8,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_348_10803",
    x: 0,
    y: 0,
    width: 1234,
    height: 166,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_348_10803"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_348_10803"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/Signature.fb4b34c69e3d9f017233c68621265612.svg";
export { ForwardRef as ReactComponent };